import { MonitorsNow } from "../../components/Adm/MonitorsNow";

export default function MonitorsNowPage() {
  return <MonitorsNow />
}
